import {
  Box,
  Card,
  CardContent,
  Grid,
  Slide,
  Typography,
  useTheme,
} from "@mui/material";
import { useGetGuidelinesQuery } from "api/api-guidelines";
import Layout from "components/Common/Layout";
import useIsMobile from "hooks/useIsMobile";
import { useState } from "react";
import Modal from "components/Common/Modal";
import AddGuide from "./add-guides";
import { useGetCurrentUserQuery } from "api/api-users-v2";

const GuidePage = () => {
  const theme = useTheme();
  const { data: guidelines, refetch } = useGetGuidelinesQuery(null);

  const { data: curr_user } = useGetCurrentUserQuery();

  const [addModal, setAddModal] = useState(false);
  const handleClose = () => setAddModal(false);
  const modalOverlaySx = {
    backgroundColor: "white !important",
    width: "50%",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "4ch",
    padding: "2ch",
    fontSize: `${theme.typography.fontSize}px !important`,
    fontFamily: `${theme.typography.fontFamily} !important`,
    height: "inherit !important",
    fontWeight: "inherit !important",
  };
  const modalSx = {
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  };
  const isMobile = useIsMobile();
  return (
    <Slide in direction="left">
      <Box sx={{ display: "flex" }} flexGrow={1}>
        <Layout
          title="Guides"
          textHeadingOptions={{
            fontWeight: "bolder",
            level: 2,
            fontSize: isMobile ? "1.2em" : "1.5em",
          }}
          headerConfig={{
            syncAction: refetch,
            left: 8,
            mid: 0,
            right: 2,
            xs: {
              left: 12,
              mid: 0,
              right: 12,
            },
            alignItems: "center",
          }}
          mode="default"
          primary={{
            children: "Add Guide",
            onClick: () => setAddModal(true),
            fullWidth: true,
          }}
        >
          {curr_user?.user_role !== "Investor" && (
            <Grid
              container
              id="guides-container"
              spacing={2}
              sx={{ minHeight: "60vh", flexWrap: "wrap" }}
            >
              {guidelines?.map((guide) => (
                <Grid item xs={6} key={guide.id}>
                  <Card variant="outlined" sx={{ borderRadius: 1 }}>
                    <CardContent>
                      <iframe
                        src={guide.link}
                        width="100%"
                        height={350}
                        allowFullScreen
                      ></iframe>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
          <Modal
            message={<AddGuide handleClose={handleClose} />}
            sx={modalSx}
            Header={<Typography variant="h4">Add Guide</Typography>}
            width={isMobile ? "90%" : "25%"}
            height="auto"
            modalContentSx={{ height: "auto" }}
            modalOverlaySx={modalOverlaySx}
            open={addModal}
            onClose={handleClose}
            closeButton
          />
        </Layout>
      </Box>
    </Slide>
  );
};

export default GuidePage;
